import { render, staticRenderFns } from "./AccBookingFacility.vue?vue&type=template&id=5246621d"
import script from "./AccBookingFacility.vue?vue&type=script&lang=js"
export * from "./AccBookingFacility.vue?vue&type=script&lang=js"
import style0 from "./AccBookingFacility.vue?vue&type=style&index=0&id=5246621d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports